import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import Dragdrop from './Dragdrop';

function IDdnd() {
  return (
    <DndProvider backend={HTML5Backend}>
      <div className='IDdnd'>
        <Dragdrop />
      </div>
    </DndProvider>
  );
}

export default IDdnd;
